import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle2 text-fun-label-and-icon row" }
const _hoisted_2 = {
  key: 0,
  class: "text-h4"
}
const _hoisted_3 = {
  key: 1,
  class: "text-h4 text-italic"
}
const _hoisted_4 = { class: "text-caption text-field-label ellipsis capitalize" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "text-body2 ellipsis" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

import { date } from "quasar"
import SfxCard from "src/components/card/SfxCard.vue"
import { DATE_TIME_FULL_MASK } from "src/util/constants/configurations"
import { IdentifierType } from "src/util/types/dataModels/identifier"
import {
  UnsubmittedWorkEntity,
  UnsubmittedWorkType,
} from "src/util/types/dataModels/unsubmittedWork"
import { computed, PropType } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxCardObject',
  props: {
  active: {
    type: Boolean,
    default: false,
  },

  objectType: {
    type: String as PropType<UnsubmittedWorkType | IdentifierType>,
    required: true,
  },

  title: {
    type: String,
  },

  titlePlaceholder: {
    type: String,
  },

  user: {
    type: String,
  },

  entityType: {
    type: String as PropType<UnsubmittedWorkEntity>,
  },

  entityData: {
    type: String,
  },

  dateTime: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()

const objectType = computed(() => {
  switch (props.objectType) {
    case "adhocCorrective": {
      return t("sfxCard.ad_hoc_corrective")
    }
    case "adhocRegular": {
      return t("sfxCard.ad_hoc_regular")
    }
    case "plannedCorrective": {
      return t("sfxCard.planned_corrective")
    }
    case "plannedRegular": {
      return t("sfxCard.planned_regular")
    }
    case "qr": {
      return t("sfxCard.qr")
    }
    case "rfid": {
      return t("sfxCard.rfid")
    }
    default: {
      return t("sfxCard.barcode")
    }
  }
})

const formattedDate = computed(() => date.formatDate(props.dateTime, DATE_TIME_FULL_MASK))
const user = computed(() => props.user || t("sfxCard.unknown_user"))
const userType = computed(() => (!props.entityType && !props.entityData) || props.user)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _directive_truncate_middle = _resolveDirective("truncate-middle")!

  return (_openBlock(), _createBlock(SfxCard, {
    class: "q-my-md",
    active: props.active,
    clickable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(objectType.value), 1),
        _createVNode(_component_q_space),
        _createElementVNode("span", null, _toDisplayString(formattedDate.value), 1)
      ]),
      (props.title)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, null, 512)), [
            [_directive_truncate_middle, props.title]
          ])
        : (props.titlePlaceholder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.titlePlaceholder), 1))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (userType.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("sfxCard.by")), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(props.entityType), 1))
      ]),
      _createElementVNode("div", _hoisted_7, [
        (userType.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(user.value), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(props.entityData), 1))
      ])
    ]),
    _: 1
  }, 8, ["active"]))
}
}

})